<template>
  <div slot="content">
    <div class="page">
      <table class="table" v-for="(item, i) in asReadDetail" :key="i">
        <tr>
          <td v-if="asReadDetail.length > 1" style="width: 650px; padding-top: -20px; vertical-align : bottom">
            <table class="table" style=" width: 100%">
              <tr>
                <td style="width: 164px; height: 40px;" class="ico ico-home">
                  <img src="@/../public/img/ot_logo3.jpg" width="150" height="59"></td>
                <td>
                  <h2 style="font-size:21px; text-align: center; padding-top:40px">
                    서비스 접수증(고객용)
                  </h2>
                </td>
                <td style="width: 100px;"></td>
              </tr>
            </table>
          </td>
          <td v-else-if="asReadDetail.length === 1" style="width: 650px; padding-top: -60px; vertical-align : bottom">
            <table class="table" style=" width: 100%">
              <tr>
                <td style="width: 164px; height: 40px;" class="ico ico-home">
                  <img src="@/../public/img/ot_logo3.jpg" width="150" height="59"></td>
                <td>
                  <h2 style="font-size:21px; text-align: center; padding-top:30px">
                    서비스 접수증(고객용)
                  </h2>
                </td>
                <td style="width: 100px;"></td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td>
            <table width="650" border="1" cellpadding="0" cellspacing="0" bordercolor="#333333" bgcolor="#333333" class="font-big" style="table-layout:fixed">
              <tr style="background-color: white;">
                <td style="width: 88px;">접수번호</td>
                <td style="width: 127px;">{{item.asId}}</td>
                <td style="width: 70px;">접수일시</td>
                <td style="width: 123px;">{{item.callDt}}</td>
                <td style="width: 88px;">고객명</td>
                <td style="width: 134px;">{{ item.custNm }}</td>
              </tr>
              <tr style="background-color: white;">
                <td height="20">사이트명</td>
                <td colspan="5">{{item.siteNm1}} {{item.siteNm2}} {{item.siteNm3}}</td>
              </tr>
              <tr style="background-color: white;">
                <td height="20">주소</td>
                <td colspan="5">{{item.addr1 + ' ' + item.addr2}}</td>
              </tr>
              <tr style="background-color: white;">
                <td height="20">연락처</td>
                <td colspan="2">{{item.telNo}}</td>
                <td>핸드폰</td>
                <td colspan="2">{{item.hpNo}}</td>
              </tr>
              <tr style="background-color: white;">
                <td height="20">모델명</td>
                <td colspan="2">{{item.modelNm}}</td>
                <td>제조번호</td>
                <td colspan="2">{{item.serialNo}}</td>
              </tr>
              <tr style="background-color: white;">
                <td height="20">구입년월</td>
                <td colspan="2">{{item.purchaseDt}}</td>
                <td>제조년월</td>
                <td colspan="2">{{item.prodDt }}</td>
              </tr>
              <tr style="background-color: white;">
                <td height="20">고장증상</td>
                <td colspan="5">{{item.asCatNm }}</td>
              </tr>
              <tr style="background-color: white;">
                <td height="40">상세증상</td>
                <td colspan="5">{{item.asCatDescription }}</td>
              </tr>
              <tr style="background-color: white;">
                <td height="40">고객요구사항</td>
                <td colspan="5" class="font12_red">
                  {{item.callMemo}}
                  &nbsp;
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td>
            <table width="100%" border="0" cellspacing="0" cellpadding="0">
              <tr>
                <td height="38" class="font12_line">
                  ※ 하드디스크의 포맷을 승인합니다.(컴퓨터 내부 자료는 유실됩니다)</td>
              </tr>
              <tr>
                <td>
                  <table width="100%" border="0" cellspacing="0" cellpadding="0">
                    <tr>
                      <td style="width: 45%;"></td>
                      <td style="width: 25%;" class="font-big">
                        상기내용을 확인합니다.
                      </td>
                      <td style="width: 30%" >
                        <table width="100%" border="1" cellpadding="0" cellspacing="0" bordercolor="#000000"
                               class="font-big">
                          <tr>
                            <td height="37">
                              고객확인 :
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td class="font-big">
                  ※ 본 접수증은 제품을 찾아가실때 필요하오니 소중히 보관하시기 바랍니다.
                </td>
              </tr>
              <tr>
                <td height="25" class="font-big">
                  ※ 문의처 : <span class="font12_red">1600-5488</span>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td v-if="asReadDetail.length > 1" style="height: 40px;">&nbsp;</td>
          <td v-if="asReadDetail.length == 1" style="height: 20px;">&nbsp;</td>
        </tr>
        <tr>
          <td>
            <hr style="border: dashed 2px #666666"/>
          </td>
        </tr>
<!--        <tr>-->
<!--          <td>&nbsp;</td>-->
<!--        </tr>-->
        <tr>
          <td style="width: 650px; vertical-align : bottom">
            <table style="width: 100%">
              <tr>
                <td style="width: 164px; height: 60px;" class="ico ico-home">
                  <img src="@/../public/img/ot_logo3.jpg" width="150" height="50"></td>
                <td v-if="asReadDetail.length > 1">
                  <h2 style="font-size:21px; text-align: center; padding-top: 50px;">
                    서비스 접수증(센터용)
                  </h2>
                </td>
                <td v-if="asReadDetail.length == 1">
                  <h2 style="font-size:21px; text-align: center; padding-top: 30px;">
                    서비스 접수증(센터용)
                  </h2>
                </td>
                <td width="100px"></td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td>
            <table width="650" border="1" cellpadding="0" cellspacing="0" bordercolor="#333333" bgcolor="#333333" class="font-big" style="table-layout:fixed">
              <tr style="background-color: white;">
                <td style="width: 88px;">접수번호</td>
                <td style="width: 127px;">{{item.asId}}</td>
                <td style="width: 70px;">접수일시</td>
                <td style="width: 123px;">{{item.callDt}}</td>
                <td style="width: 88px;">고객명</td>
                <td style="width: 134px;">{{item.custNm}}</td>
              </tr>
              <tr style="background-color: white;">
                <td height="20">사이트명</td>
                <td colspan="5">{{item.siteNm1}} {{item.siteNm2}} {{item.siteNm3}}</td>
              </tr>
              <tr style="background-color: white;">
                <td height="20">주소</td>
                <td colspan="5">{{item.addr1 + ' ' + item.addr2}}</td>
              </tr>
              <tr style="background-color: white;">
                <td height="20">연락처</td>
                <td colspan="2">{{item.telNo}}</td>
                <td>핸드폰</td>
                <td colspan="2">{{item.hpNo}}</td>
              </tr>
              <tr style="background-color: white;">
                <td height="20">모델명</td>
                <td colspan="2">{{item.modelNm}}</td>
                <td>제조번호</td>
                <td colspan="2">{{item.serialNo}}</td>
              </tr>
              <tr style="background-color: white;">
                <td height="20">구입년월</td>
                <td colspan="2">{{item.purchaseDt}}</td>
                <td>제조년월</td>
                <td colspan="2">{{item.prodDt }}</td>
              </tr>
              <tr style="background-color: white;">
                <td height="20">고장증상</td>
                <td colspan="5">{{item.asCatNm }}</td>
              </tr>
              <tr style="background-color: white;">
                <td height="40">상세증상</td>
                <td colspan="5">{{item.asCatDescription }}</td>
              </tr>
              <tr style="background-color: white;">
                <td height="40">고객요구사항</td>
                <td colspan="5" class="font12_red">
                  {{item.callMemo}}
                  &nbsp;
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td>
            <table width="100%" border="0" cellspacing="0" cellpadding="0">
              <tr>
                <td height="38" class="font12_line">
                  ※ 하드디스크의 포맷을 승인합니다.(컴퓨터 내부 자료는 유실됩니다)</td>
              </tr>
              <tr>
                <td>
                  <table width="100%" border="0" cellspacing="0" cellpadding="0" style="padding-bottom: 10px">
                    <tr>
                      <td style="width: 45%;">
                        &nbsp;</td>
                      <td style="width: 25%;" class="font-big">
                        상기내용을 확인합니다.
                      </td>
                      <td style="width: 30%" >
                        <table width="100%" border="1" cellpadding="0" cellspacing="0" bordercolor="#000000"
                               class="font-big">
                          <tr>
                            <td height="37">
                              고객확인 :
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td v-if="asReadDetail.length > 1" style="height:70px;"></td>
          <td v-else-if="asReadDetail.length === 1"></td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>

import Layout from '@/components/Slot/ModalSlot.vue';

export default {
  components: {Layout},
  name : 'ProcsHstScreen',
  props: {
    asReadDetail: {
      Type: Object,
      default: {
        asId: ''
      }
    },
  },
  data() {
    return {
      //menu
      //data: [],
    };
  },
  mounted() {
    console.log(this.asReadDetail)
  }
}
</script>
